<template>
  <div>
    <b-card no-body>
      <b-tabs
        pills
        class="m-2"
        nav-class="m-1"
      >
        <b-tab>
          <template #title>
            <span class="d-none d-sm-inline ml-2 mr-2">계약 통계</span>
          </template>
          <ContractStatsView />
        </b-tab>

        <b-tab>
          <template #title>
            <span class="d-none d-sm-inline ml-2 mr-2">게시글 통계</span>
          </template>
          <ContentStatsView />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>

import { BTab, BTabs } from 'bootstrap-vue'
import { ref, onMounted } from "@vue/composition-api"
import ContractStatsView from './stats-tab-view/ContractStatsView.vue'
import ContentStatsView from './stats-tab-view/ContentStatsView.vue'

export default {
  components: {
    BTab,
    BTabs,
    ContractStatsView,
    ContentStatsView,
  },
  computed: {

  },
  setup() {
    onMounted(() => {

    })

    return {

    }
  },
}
</script>

<style lang="scss">
#drugInfoPreview .modal-dialog {
  max-width: 1150px;
}
</style>
